import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
export class LoginComponent {
constructor(
      ) {}

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'hd-login',
    template: `
      <ng-content></ng-content>
    `,
    styles: [`
      :host {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
            -ms-flex-flow: row;
                flex-flow: row;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        height: 100%;
        width: 100%; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LoginComponent_tsickle_Closure_declarations() {
/** @type {?} */
LoginComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LoginComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
